import { render, staticRenderFns } from "./SetPasswordNotice.vue?vue&type=template&id=4c1e8204&scoped=true"
import script from "./SetPasswordNotice.vue?vue&type=script&lang=js"
export * from "./SetPasswordNotice.vue?vue&type=script&lang=js"
import style0 from "./SetPasswordNotice.vue?vue&type=style&index=0&id=4c1e8204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1e8204",
  null
  
)

export default component.exports